import { Button } from '@givebutter/primitives/button';
import { faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ExportDialog from 'assets/js/components/ExportDialog';
import { EventAttendeesTable } from 'assets/js/pages/campaign-settings/campaign-event/EventAttendeesTable';
import { EventAttendeesTableProvider } from 'assets/js/pages/campaign-settings/campaign-event/EventAttendeesTableProvider';
import * as DropdownMenu from 'components/dropdown-menu';
import * as TicketActions from 'components/pages/tickets/TicketActions';
import { createTicketColumns } from 'components/pages/tickets/ticketColumns';
import * as Table from 'components/table';
import { TableCoreResourceProvider } from 'components/table/TableCoreResourceContext';
import { TicketScanModal } from 'components/ticket-scan-modal';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const EventAttendees = () => {
    const { accountId } = useCurrentAccount();

    return (
        <TableCoreResourceProvider
            resource={'tickets'}
            initialState={{
                sortingState: [{ id: 'created_at', desc: true }],
                columnVisibilityState: {
                    email: false,
                    phone: false,
                    price: false,
                    discount: false,
                },
            }}
            columns={columnHelper => {
                const ticketColumns = createTicketColumns(columnHelper);

                return [
                    ticketColumns.contactName({ accountIdPath: `/accounts/${accountId}` }),
                    ticketColumns.createdAt(),
                    ticketColumns.type(),
                    ticketColumns.number(),
                    ticketColumns.checkedInAt(),
                    ticketColumns.latestCheckin(),
                    ticketColumns.email(),
                    ticketColumns.phone(),
                    ticketColumns.price(),
                    ticketColumns.discount(),
                    columnHelper.display({
                        id: Table.Constants.Actions,
                        cell: info => {
                            const ticket = info.row.original;

                            return (
                                <TicketActions.Root ticket={ticket}>
                                    <DropdownMenu.Root>
                                        <Table.RowDropdownTrigger />
                                        <DropdownMenu.Content sideOffset={5} align={'end'}>
                                            <TicketActions.ViewTransaction />
                                            <TicketActions.Reassign />
                                            <TicketActions.Download />
                                            <TicketActions.Revoke />
                                            <TicketActions.Resend />
                                        </DropdownMenu.Content>
                                    </DropdownMenu.Root>
                                </TicketActions.Root>
                            );
                        },
                        meta: {
                            ignoreLink: true,
                        },
                    }),
                ];
            }}
            options={{
                enableHiding: true,
                enableSorting: false,
                enablePinning: true,
                enableExpanding: true,
                meta: {
                    enableColumnOrder: true,
                },
            }}
        >
            <EventAttendeesTableProvider>
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                        <h1 className="text-2xl font-medium">Attendees</h1>
                        <div className="flex gap-2">
                            <ExportDialog.Root reportType="attendees">
                                <ExportDialog.Trigger asChild={true}>
                                    <Button variant="outline" color="neutral">
                                        <FontAwesomeIcon icon={faFileExport} />
                                        Export
                                    </Button>
                                </ExportDialog.Trigger>
                            </ExportDialog.Root>
                            <TicketScanModal />
                        </div>
                    </div>
                    <EventAttendeesTable />
                </div>
            </EventAttendeesTableProvider>
        </TableCoreResourceProvider>
    );
};

export { EventAttendees };
